var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bot",
    transform: "translate(-13.5 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8542",
    "data-name": "Path 8542",
    d: "M26.833,18.667H26.48l.007-.647a2,2,0,0,0-2-2.02h-3.32V14.482a1.333,1.333,0,1,0-1.333,0V16H16.5a2,2,0,0,0-2,2v.667h-.333a.667.667,0,0,0-.667.667V22a.667.667,0,0,0,.667.667H14.5V24a2,2,0,0,0,2,2h7.927a2.007,2.007,0,0,0,2-1.98l.013-1.353h.393A.667.667,0,0,0,27.5,22V19.333A.667.667,0,0,0,26.833,18.667Zm-1.74,5.34a.669.669,0,0,1-.667.66H16.5A.668.668,0,0,1,15.833,24V18a.668.668,0,0,1,.667-.667h7.987a.667.667,0,0,1,.667.673Z",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_843",
    "data-name": "Rectangle 843",
    width: 1.333,
    height: 2,
    transform: "translate(17.167 19.333)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_844",
    "data-name": "Rectangle 844",
    width: 1.333,
    height: 2,
    transform: "translate(22.5 19.333)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_845",
    "data-name": "Rectangle 845",
    width: 4,
    height: 1.333,
    transform: "translate(18.5 22)",
    fill: "#325ae7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/bot.646d6f97e93f6beea0ac2d66e7f3d8f0.svg";
export { ForwardRef as ReactComponent };